(function () {
  var header;
  var announcement;
  var observer;
  var initialized = false;
  var visibleHeight = -1;
  var headerHeight = 0;
  var announcementHeight = 0;

  function updateScroll() {
    if (!header) return;
    var nextVisibleHeight = Math.max(0, header.getBoundingClientRect().bottom);
    if (announcement) announcement.inert = announcement.getBoundingClientRect().bottom <= 0;
    if (nextVisibleHeight !== visibleHeight) {
      visibleHeight = nextVisibleHeight;
      document.documentElement.style.setProperty('--luxster-visible-header-height', visibleHeight + 'px');
    }
  }

  function sync() {
    if (!header) return;
    var nextHeaderHeight = header.getBoundingClientRect().height;
    var nextAnnouncementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
    if (nextHeaderHeight !== headerHeight) {
      headerHeight = nextHeaderHeight;
      document.documentElement.style.setProperty('--luxster-header-height', headerHeight + 'px');
    }
    if (nextAnnouncementHeight !== announcementHeight) {
      announcementHeight = nextAnnouncementHeight;
      document.documentElement.style.setProperty('--luxster-top-header-height', announcementHeight + 'px');
    }
    updateScroll();
  }

  function bindHeader() {
    if (observer) observer.disconnect();
    header = document.getElementById('shopify-section-header');
    if (!header) return;
    announcement = header.querySelector('.top-header');
    visibleHeight = -1;
    sync();
    if (window.ResizeObserver) {
      observer = new ResizeObserver(sync);
      observer.observe(header);
      if (announcement) observer.observe(announcement);
    }
  }

  function init() {
    if (initialized) { sync(); return; }
    initialized = true;
    bindHeader();
    window.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('pageshow', sync);
    document.addEventListener('shopify:section:load', bindHeader);
    if (document.fonts) document.fonts.ready.then(sync);
  }

  window.LuxsterHeaderHeightSync = { init: init, sync: sync };
})();
